import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { InventoryPushChannelSchema } from "./get-inventory-push-settings";

export const updateInventoryPushSettings = {
  name: "updateInventoryPushSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    channels: z.array(
      z.object({ channel: InventoryPushChannelSchema, enabled: z.boolean() }),
    ),
  }),
  output: z.object({}),
};
